import React from 'react';
import {
    CircularProgress, 
    Backdrop,
} from '@mui/material';

const PageLoader = ({openLoader, isGlobal=false}) => {

    return (
        isGlobal ? 
        (<Backdrop open={openLoader} sx={{ color: "#fff", zIndex: 1301 }}>
            <CircularProgress size={60} thickness={4} />
        </Backdrop>) :  openLoader && (<CircularProgress size={30} thickness={4} />)
    )
}

export default PageLoader;
